<ng-container *ngrxLet="(status$ | async | ready)?.properties?.active?.value as statusValue">
  <ng-container *ngrxLet="installationFeaturesStore.isAnyRoomWithDevice$ as isAnyRoomWithDevice">
    <div [class.toggle-wrapper]="isInSettingsPage">
      <div class="flex flex-row items-center gap-4">
        <ng-container *ngIf="isInSettingsPage; else SrcDetailsOverlayPage">
          <p class="max-w-[60%]">
            {{ '+INSTALLATIONS.INSTALLATION.SRC.ACTIVATION.TITLE' | translate
            }}<mat-icon
              class="info-icon"
              matTooltip="{{
                '+INSTALLATIONS.INSTALLATION.SRC.ACTIVATION.SLIDE_TOGGLE_TOOLTIP' | translate
              }}"
              *ngIf="!statusValue && !isAnyRoomWithDevice"
              matTooltipPosition="below"
            >
              error_outline
            </mat-icon>
          </p>
        </ng-container>

        <ng-template #SrcDetailsOverlayPage>
          <div
            class="indicator yellow flex flex-row gap-[8px]"
            matTooltip="{{
              '+INSTALLATIONS.INSTALLATION.SRC.ACTIVATION.SLIDE_TOGGLE_TOOLTIP' | translate
            }}"
            *ngIf="!statusValue && !isAnyRoomWithDevice"
            (click)="stopEvent($event)"
          >
            <mat-icon>error_outline</mat-icon>
          </div>
        </ng-template>

        <mat-slide-toggle
          class="flex-grow"
          #srcActivationSwitch
          [class.deactivated]="!statusValue && !isAnyRoomWithDevice"
          [class.removeMdcIcon]="!isInSettingsPage"
          [viConfirm]="
            statusValue
              ? {
                  title: '+INSTALLATIONS.INSTALLATION.SRC.DEACTIVATION.MODAL.TITLE' | translate,
                  content: '+INSTALLATIONS.INSTALLATION.SRC.DEACTIVATION.MODAL.CONTENT' | translate,
                  cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
                  confirmBtn: 'GENERAL.BUTTON.ACCEPT' | translate
                }
              : {
                  title: '+INSTALLATIONS.INSTALLATION.SRC.ACTIVATION.MODAL.TITLE' | translate,
                  content: '+INSTALLATIONS.INSTALLATION.SRC.ACTIVATION.MODAL.CONTENT' | translate,
                  cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
                  confirmBtn: 'GENERAL.BUTTON.ACCEPT' | translate
                }
          "
          gtm="onToggle"
          gtmAction="Single room control"
          gtmCategory="singleRoomControl"
          (confirm)="openActivationSrcModal(srcActivationSwitch, true)"
          (cancel)="openActivationSrcModal(srcActivationSwitch, false)"
          [disabled]="!statusValue && !isAnyRoomWithDevice"
          [checked]="statusValue"
          (change)="onSrcActivationSwitchChange(srcActivationSwitch)"
        ></mat-slide-toggle>
      </div>
    </div>
  </ng-container>
</ng-container>
